export var setRef = function setRef(ref, value) {
  if (ref) {
    ref.current = value;
  }
};